import api from "~/services/apis/antecipeApi";

const BASE = "antecipebackoffice/advancepayment";

export const getMergeGroups = async (params, { signal } = {}) => {
  const response = await api.get(`${BASE}/merge-groups`, { params, signal });
  return response.data;
};

export const previewMerge = async (advancePaymentIds) => {
  const response = await api.post(`${BASE}/merge/preview`, { advancePaymentIds });
  return response.data;
};

export const mergePackages = async (advancePaymentIds) => {
  const response = await api.post(`${BASE}/merge`, { advancePaymentIds });
  return response.data.data;
};

export const getPackageMoves = async (id) => {
  const response = await api.get(`${BASE}/${id}/moves`);
  return response.data.data;
};

export const getPackageVacanciesBackoffice = async (id, { limit, offset }) => {
  const response = await api.get(`${BASE}/${id}/vacancies`, { params: { limit, offset } });
  return response.data;
};
